// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function toString(zoneStrategy) {
  if (zoneStrategy) {
    return "Specific Zones";
  } else {
    return "All";
  }
}

function fromString(zoneStrategy) {
  switch (zoneStrategy) {
    case "All" :
        return /* All */0;
    case "Specific Zones" :
        return /* Specific */1;
    default:
      return ErrorUtils$Catalyst.raiseError("SurgeZoneStartegy.re", "Invalid zoneStrategy ", zoneStrategy);
  }
}

function getListOfStrategyTypes(param) {
  return {
          hd: /* All */0,
          tl: {
            hd: /* Specific */1,
            tl: /* [] */0
          }
        };
}

export {
  toString ,
  fromString ,
  getListOfStrategyTypes ,
  
}
/* No side effect */
